import Nav from "./../Page/Share/Nav/Nav";
const Post6 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Luna hair beauty branding & packaging
          </h2>
          {/* items?.Description */}
          <p>
            Luna is a passionate hair & beauty center brand born with the mission of helping women with professional specialists and the best products. Luna is simple yet memorable and stunning. It's centered on two elements created exclusively for the project: a logotype and a symbol. The logotype is feminine, modern, and elegant. It has the same routes as the symbol, which makes them perfect. The emblem is designed with the letter L and the hair shape. It reflects the change and the beauty.
          </p>
          {/* img section */}
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/305658153700387.63346325b7779.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/3a5e2a153700387.63346325bd8fa.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/2800_opt_1/8bbf95153700387.63346325bc216.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/038b80153700387.63346325bf120.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/1cdc70153700387.63346325b92eb.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/3d2b31153700387.63346325bba09.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/038d53153700387.63346325be94a.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/12a61b153700387.63346325be19c.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/747537153700387.63346325ba275.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/d86601153700387.63346325bb1eb.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/7d8454153700387.63346325b8af5.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/b98819153700387.63346325bc9b4.jpg" alt="" />
          <img src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/8fec6b153700387.63346325b9ab6.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post6;
